import React, { useEffect, useState } from "react";
import CommonTitle from "../../components/CommonTitle";
import bap from "../../assets/icons/bap.webp";
import CustomInput from "../../components/CustomInput";
import {
  getBanners,
  getIgPosts,
  getInitialMessage,
  getPosts,
  updateInitialMessage,
} from "../../services/ecommerceElements";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../../components/ui-elements/Notification";
import BannerCard from "./BannerCard";
import InDevelopment from "../InDevelopment";
import IgCard from "./IgCard";
import PostCard from "./PostCard";

const BannersAndPosts = () => {
  const [initialMessage, setInitialMessage] = useState("");

  {
    /**Top slide section */
  }
  const [banners, setBanners] = useState([]);

  {
    /**posts section. Could be offers, news, etc */
  }
  const [posts, setPosts] = useState([]);

  {
    /**IG posts section */
  }
  const [igPosts, setIgPosts] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res1 = await getInitialMessage();
        setInitialMessage(res1?.docs?.[0].message || "");

        const res2 = await getBanners();
        setBanners(res2.docs);

        const res3 = await getIgPosts();
        setIgPosts(res3?.docs);
        // setIgPosts(res2.docs);

        const res4 = await getPosts();
        setPosts(res4.docs);
      } catch (err) {
        Notification({
          title: "Error",
          text: "Error al cargar los elementos",
          type: "Error",
        });

        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchData();
    setLoading(false);
  }, []);

  /* Fetchear info previamente */

  const handleUpdateInitialMessage = (message) => {
    if (message.trim() == "") {
      Notification({
        title: "Error",
        text: "El mensaje no puede estar vacío",
        type: "Error",
      });
      return;
    }
    const fetchData = async () => {
      try {
        const { data } = await updateInitialMessage({ message: message });
        Notification({
          title: "Operación completada",
          text: "El mensaje ha sido actualizado con éxito",
          type: "Success",
        });
      } catch (err) {
        Notification({
          title: "Error",
          text: "Error al actualizar el mensaje inicial",
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchData();
  };

  const handleAddBanner = (newBanner) => {
    setBanners([...banners, newBanner]);
  };

  const handleDeleteBanner = (id) => {
    setBanners(banners.filter((banner) => banner.id != id));
  };

  const handleAddIgPost = (newIgPost) => {
    setIgPosts([...igPosts, newIgPost]);
  };

  const handleDeleteIgPost = (id) => {
    setIgPosts(igPosts.filter((igPost) => igPost.id != id));
  };

  const handleAddPost = (newPost) => {
    setPosts([...posts, newPost]);
  };

  const handleDeletePost = (id) => {
    setPosts(posts.filter((post) => post.id != id));
  };

  return (
    <div className="w-full h-full flex flex-col items-center justify-start">
      <CommonTitle
        title="Banners y Posts"
        text="Aquí podrás modificar las los banners y publicaciones de Ig en el ecommerce"
        img={bap}
      />
      <div className="max-w-[1280px] w-full flex flex-col gap-4 p-4 py-6 justify-center items-start font-poppins">
        {/* IG CARD */}

        <div className="flex flex-row w-full items-center justify-center gap-2">
          <CustomInput
            title="Mensaje inicial ecommerce"
            value={initialMessage}
            onChange={(e) => setInitialMessage(e.target.value)}
            placeholder="Ej: Bienvenidos a nuestro ecommerce"
            inputType="text"
            required={true}
          />
          <button
            className="bg-dark-green text-white rounded-full py-2 px-6 text-base font-poppins hover:bg-accent-green transition-all duration-100"
            onClick={(e) => {
              e.preventDefault();
              handleUpdateInitialMessage(initialMessage);
            }}
          >
            Actualizar
          </button>
        </div>

        <h3 className="text-2xl font-semibold">Banners (Slider)</h3>
        <div className="flex flex-row overflow-x-auto p-2 md:p-6 rounded-2xl gap-4 w-full bg-light-green">
          {banners &&
            banners?.map((banner, i) => {
              return (
                <BannerCard
                  key={i}
                  prevData={banner}
                  removeFromParent={handleDeleteBanner}
                />
              );
            })}
          <BannerCard
            key={banners.length}
            uploadToParent={handleAddBanner}
            removeFromParent={handleDeleteBanner}
          />
        </div>

        <h3 className="text-2xl font-semibold">Posts</h3>
        <div className="flex flex-row overflow-x-auto p-2 md:p-6 rounded-2xl gap-4 w-full bg-light-green">
          {posts &&
            posts?.map((post, i) => (
              <PostCard
                key={i}
                prevData={post}
                removeFromParent={handleDeletePost}
              />
            ))}
          <PostCard
            key={posts.length}
            uploadToParent={handleAddPost}
            removeFromParent={handleDeletePost}
          />
        </div>

        <h3 className="text-2xl font-semibold">Publicaciones de Instagram</h3>
        <div className="flex flex-row overflow-x-auto p-2 md:p-6 rounded-2xl gap-4 w-full bg-light-green">
          {igPosts &&
            igPosts?.map((post, i) => (
              <IgCard
                key={i}
                prevData={post}
                removeFromParent={handleDeleteIgPost}
              />
            ))}
          <IgCard
            key={igPosts.length}
            uploadToParent={handleAddIgPost}
            removeFromParent={handleDeleteIgPost}
          />
        </div>
      </div>
    </div>
  );
};

export default BannersAndPosts;
